import DestroyIFrame from 'wrapper/lib/frames/utils/DestroyIFrame'

const DeleteFrame = (message) => {
    if (message.includes('FRAME/DELETE_CHILD/')) {
        const tag = message.replace('FRAME/DELETE_CHILD/', '')
        DestroyIFrame(tag)
    }
}

export default DeleteFrame
